<ng-container>
  <mat-progress-bar
    *ngIf="loadingSites || loadingRegions || loadingRegionSites"
    mode="indeterminate"
    [color]="'accent'"
    [style.height]="'2px'"></mat-progress-bar>
  <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <div class="row align-items-start">
        <div class="col-10">
          <div class="row align-items-center">
            <ng-container *ngFor="let field of reportFilters">
              <mat-form-field
                *ngIf="field.type === 'date-range'"
                appearance="outline"
                class="col-12 col-md-4 col-lg-4">
                <mat-label>
                  {{ field.label || 'Enter a date range'
                  }}{{ field?.validators?.required ? ' *' : '' }}
                </mat-label>
                <mat-date-range-input
                  [rangePicker]="picker"
                  [formGroup]="dynamicForm.get(field.name)">
                  <input
                    matStartDate
                    placeholder="Start date"
                    formControlName="begin_date" />
                  <input
                    matEndDate
                    formControlName="end_date"
                    placeholder="End date" />
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker">
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <mat-error
                  *ngIf="
                    dynamicForm
                      .get(field.name)
                      .controls.begin_date.hasError('required')
                  ">
                  {{ field?.label ? field.label : 'Range' }} is required.
                </mat-error>
              </mat-form-field>

              <mat-form-field
                *ngIf="field.type === 'date'"
                appearance="outline"
                class="col-12 col-md-4 col-lg-4">
                <mat-label>
                  {{ field.label || 'Enter a date' }}
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  [formControlName]="field.name"
                  placeholder="{{ field.label || 'Choose a date' }}"
                  [required]="field?.validators?.required || false"
                  [(value)]="field.value" />
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field
                *ngIf="field.type === 'select' && field.visible !== false"
                appearance="outline"
                class="col-12 col-md-4 col-lg-4">
                <mat-label>{{ field.label || 'Select' }}</mat-label>
                <mat-select
                  [formControlName]="field.name"
                  [(value)]="field.value"
                  [required]="field?.validators?.required || false"
                  [multiple]="field?.multiple || false">
                  <mat-option
                    *ngFor="let option of field.options"
                    [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field
                *ngIf="field.type === 'text'"
                appearance="outline"
                class="col-12 col-md-4 col-lg-4">
                <input
                  matInput
                  [formControlName]="field.name"
                  placeholder="{{ field.label || 'Text' }}"
                  [required]="field?.validators?.required || false"
                  [(value)]="field.value" />
              </mat-form-field>

              <mat-form-field
                *ngIf="field.type === 'autocomplete'"
                appearance="outline"
                size
                class="col-12 col-md-4 col-lg-4">
                <input
                  matInput
                  [required]="field?.validators?.required || false"
                  [formControlName]="field.name"
                  placeholder="{{ field.label || 'Select' }}"
                  [matAutocomplete]="auto" />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [multiple]="field?.multiple || false"
                  [(value)]="field.value">
                  <mat-option
                    *ngFor="let option of field.options"
                    [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </ng-container>
          </div>
        </div>

        <div class="col justify-content-end d-flex">
          <button
            mat-flat-button
            color="accent"
            type="submit"
            class="rounded"
            [disabled]="dynamicForm.invalid">
            {{ submitButtonText }}
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
